import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsFullScreenEnterNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M3.25 3.625c0-.207.168-.375.375-.375H7V2H3.625C2.728 2 2 2.728 2 3.625V7h1.25zM9 2v1.25h3.375c.207 0 .375.168.375.375V7H14V3.625C14 2.728 13.273 2 12.375 2zM14 9v3.375c0 .897-.727 1.625-1.625 1.625H9v-1.25h3.375a.375.375 0 00.375-.375V9zM3.25 9H2v3.375C2 13.272 2.728 14 3.625 14H7v-1.25H3.625a.375.375 0 01-.375-.375z" />
      </g>
    </svg>
  )
);
SvgActionsFullScreenEnterNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsFullScreenEnterNormalXsmall;
